module.exports = __webpack_public_path__ + "static/media/visa.cee02107.webp";